// extracted by mini-css-extract-plugin
export var beatLoaderCenter = "TourBookingPrivate-module--beatLoaderCenter--biuKO";
export var container = "TourBookingPrivate-module--container--LRIyw";